<template>
  <div :style="{width: '100%'}" class="packages flex-col gap-y-md" data-dusk="packages">
    <template v-for="(policyPackage, idx) in packages">
      <PackageComponent
        :customer-id="customerId"
        :policy-package="policyPackage"
        :key="idx"
        data-dusk="package"
      />
    </template>
  </div>
</template>

<script>
import PackageComponent from './PackageComponent.vue';

export default {
  name: "PackagesComponent",
  components: {
    PackageComponent
  },
  props: {
    customerId: {
      type: Number,
      required: true,
    },
    packages: {
      type: Array,
      required: true,
    }
  },
}
</script>

<style lang="scss">
@import "~@/_default.scss";
.packages {
  .nothing-found {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: $spacing-xxl;
  }

  .premium {
    border-radius: 9999px;
    color: $brand-primary;
    background-color: transparent;
    padding-right: $spacing-sm;
    padding-left: $spacing-sm;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: $font-size-small;
  }

  .logo {
    height: $spacing-lg;
    width: auto;
  }
}
</style>
